export default __webpack_public_path__ + "static/media/learose3-768w.04c34edf.png";